export const paymentModeAr = {
  "Donner le Nom": "أعط الاسم",
  "Code": "الرمز",
  "Donner le Code": "أعط الرمز",

  // server Side  

  "La methode deja existe.": "طريقة الدفع موجودة بالفعل.",
  "le nom est obligatoire.": "الاسم مطلوب.",
  "le code est obligatoire.": "الرمز إلزامي.",
  

}